var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPrint(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2227_33457)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.58332 1.83366C4.58332 1.3274 4.99373 0.916992 5.49999 0.916992H16.5C17.0063 0.916992 17.4167 1.3274 17.4167 1.83366V7.33366H18.3333C19.0627 7.33366 19.7621 7.62339 20.2779 8.13912C20.7936 8.65484 21.0833 9.35431 21.0833 10.0837V14.667C21.0833 15.3963 20.7936 16.0958 20.2779 16.6115C19.7621 17.1273 19.0627 17.417 18.3333 17.417H17.4167V20.167C17.4167 20.6733 17.0063 21.0837 16.5 21.0837H5.49999C4.99373 21.0837 4.58332 20.6733 4.58332 20.167V17.417H3.66666C2.93731 17.417 2.23784 17.1273 1.72211 16.6115C1.20639 16.0958 0.916656 15.3963 0.916656 14.667V10.0837C0.916656 9.35431 1.20639 8.65484 1.72211 8.13912C2.23784 7.62339 2.93731 7.33366 3.66666 7.33366H4.58332V1.83366ZM6.41666 19.2503H15.5833V13.7503H6.41666V19.2503ZM17.4167 15.5837V12.8337C17.4167 12.3274 17.0063 11.917 16.5 11.917H5.49999C4.99373 11.917 4.58332 12.3274 4.58332 12.8337V15.5837H3.66666C3.42354 15.5837 3.19038 15.4871 3.01848 15.3152C2.84657 15.1433 2.74999 14.9101 2.74999 14.667V10.0837C2.74999 9.84054 2.84657 9.60739 3.01848 9.43548C3.19038 9.26357 3.42354 9.16699 3.66666 9.16699H18.3333C18.5764 9.16699 18.8096 9.26357 18.9815 9.43548C19.1534 9.60739 19.25 9.84055 19.25 10.0837V14.667C19.25 14.9101 19.1534 15.1433 18.9815 15.3152C18.8096 15.4871 18.5764 15.5837 18.3333 15.5837H17.4167ZM15.5833 2.75033V7.33366H6.41666V2.75033H15.5833Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2227_33457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrint);
export default __webpack_public_path__ + "static/media/print.ebcef3ccb2d674646c277b736fb1ca55.svg";
export { ForwardRef as ReactComponent };